import { QueryClient, QueryCache } from "@tanstack/react-query";

interface ErrorObject {
  response: { status: number };
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 1000 * 60 * 5,
      staleTime: 3000,
      retry: 0,
    },
  },
  queryCache: new QueryCache({
    onError: (error: unknown) => {
      const err = error as ErrorObject;
      if (err?.response?.status === 404) {
        window.location.href = "/error";
      }
    },
  }),
});

export default queryClient;
